import { createQueryKeys } from '@lukemorales/query-key-factory';

export const geo = createQueryKeys('geo', {
  country: null,
});
